module.exports = __webpack_public_path__ + "img/reward.24821501.svg";